import { Button } from 'bitmovin-player-ui';
import { useContext } from 'react';
import { MixpanelContext } from '../../../contexts/MixpanelContext';
import { EVENT } from '../../../contexts/MixpanelConstants';
import h from '../../../helpers/common';
import { getMixpanelItemTypeProperty } from '../../../contexts/MixpanelHelper';
import channelsUtil from '../../../helpers/channelsUtil';

export const useStartoverButton = (program, startOverPlayback) => {
    const { track } = useContext(MixpanelContext);

    if (!program) {
        return null;
    }

    const onStartOver = () => {
        track(h.getScreen() + ' - ' + EVENT.LIVE_TV.START_OVER_CLICK, getMixpanelItemTypeProperty(program));
        if (!program || channelsUtil.isNow(program)) return;
    };

    // TODO: check is all CSS classes are needed - `fa`, `custom-info-icon`, etc.
    const startOverButton = new Button({ cssClass: 'fa custom-info-icon ui-startover-btn bmpui-ui-button' });
    startOverButton.onClick.subscribe(function () {
        onStartOver();
        if (startOverPlayback) {
            startOverPlayback();
        }
    });

    return startOverButton;
};
